import React from "react";
import { MenuPopover, MenuItem, MenuDivider, GLYPH } from "./v2";

// Role-aware list ⋯ menu (frames 1b open menu ≡ 2d creator board — ONE
// component, the kit's MenuPopover; the colleague variant is the same
// component role-FILTERED, 2d right board). Purely presentational: gating
// mirrors the platform's existing `can_manage` / `is_default` / count logic
// exactly (creator/ClubAdmin: full set incl. destructive Delete; colleague:
// Copy players to… + Share to chat only; My Radar is personal and cannot be
// renamed/described/shared/deleted). Handlers arrive from the host — the
// same existing handlers as before, never new logic.
//
// Item order + dividers per artboard: Rename list · Edit description ·
// Move players to… · Copy players to… ── Manage sharing · Share to chat ──
// Delete list (danger). Dividers only render between non-empty groups.
const ClubListMenu = ({
  canManage = false,
  isDefault = false,
  count = 0,
  onRename,
  onEditDescription,
  onMovePlayers,
  onCopyPlayers,
  onManageSharing,
  onShareToChat,
  onDelete,
  ...rest
}) => {
  const groups = [
    [
      canManage && !isDefault && (
        <MenuItem key="rename" onClick={onRename}>Rename list</MenuItem>
      ),
      canManage && !isDefault && (
        <MenuItem key="desc" onClick={onEditDescription}>Edit description</MenuItem>
      ),
      canManage && count > 0 && (
        <MenuItem key="move" onClick={onMovePlayers}>Move players to{GLYPH.ellipsis}</MenuItem>
      ),
      count > 0 && (
        <MenuItem key="copy" onClick={onCopyPlayers}>Copy players to{GLYPH.ellipsis}</MenuItem>
      ),
    ].filter(Boolean),
    [
      canManage && !isDefault && (
        <MenuItem key="sharing" onClick={onManageSharing}>Manage sharing</MenuItem>
      ),
      <MenuItem key="chat" onClick={onShareToChat}>Share to chat</MenuItem>,
    ].filter(Boolean),
    [
      canManage && !isDefault && (
        <MenuItem key="delete" destructive onClick={onDelete}>Delete list</MenuItem>
      ),
    ].filter(Boolean),
  ].filter((g) => g.length > 0);

  return (
    <MenuPopover {...rest}>
      {groups.map((items, i) => (
        <React.Fragment key={i}>
          {i > 0 && <MenuDivider />}
          {items}
        </React.Fragment>
      ))}
    </MenuPopover>
  );
};

export default ClubListMenu;
